module.exports = __webpack_public_path__ + "img/osmrtnice.svg";